import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  setReplayRoute,
  startReplayTracking,
  stopReplayTracking,
} from "@/lib/analytics/replay";

export default function ReplayTracker() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    setReplayRoute(pathname);
  }, [pathname]);

  useEffect(() => {
    startReplayTracking();
    return stopReplayTracking;
  }, []);

  return null;
}
